export default "/build/assets/logo-autoclaim.1c6dae1bc6ad46b05adefcc482f856b0.svg";